import React from 'react';
import { Box, TextField, MenuItem, Alert } from '@mui/material';
import NivoSchemeSelector from '../../../../../Components/Form/NivoSchemeSelector';
import { BlockSettingsProps } from './types';

export const SumFieldsSettings: React.FC<BlockSettingsProps> = ({
    kedo,
    state,
    handleChangeSettings,
}) => {
    const sumFieldValue = state.item.settings.sum_field || '';

    if (!state.item.defDossier) return <Alert severity="info">{kedo.t('Select an Entity first')}</Alert>;
    return (
        <Box sx={{ mt: 2 }}>
            <TextField
                select
                size="small"
                fullWidth
                value={sumFieldValue}
                label={kedo.t('Sum field')}
                helperText="Placeholder for SelectList component logic"
                onChange={(e) => handleChangeSettings('sum_field', e.target.value)}
                margin="normal"
            >
                <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                {sumFieldValue ? (
                    <MenuItem value={sumFieldValue}>{sumFieldValue}</MenuItem>
                ) : null}
            </TextField>
            <NivoSchemeSelector
                kedo={kedo}
                value={state.item.settings.scheme}
                onChange={(e: any) => handleChangeSettings('scheme', e.target.value)}
                name={'scheme'}
                sx={{ mt: 2 }}
            />
        </Box>

    );

};
